const formatDate = (dateString,) => {

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const date = new Date(dateString);

  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: userTimeZone,
  };

  return date.toLocaleString('en-US', options);
};


const formatTime = (dateString) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(dateString);

  const options = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: userTimeZone
  };

  return date.toLocaleString('en-US', options);
};



const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;
const day = today.getDate();
const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
const formattedTime = today.toTimeString().split(" ")[0];

var datearray = formattedDate.split("-");

const formatDateDDMMYYYY = (date) =>

  new Date(date).toLocaleString('en-US', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });


const formatDateDDMMYYYYmonth = (date) => {
  const d = new Date(date);
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // shows time in 12-hour format with AM/PM
  });
};

const formatDateDDMMYYYYmonthNew = (date) => {
  const d = new Date(date);
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',


  });
};


function formatDateIndian(dateString) {
  if (!dateString) return "";

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata"
  };

  const date = new Date(dateString);
  return date.toLocaleString("en-IN", options);
}




const formatDateDD_MM_YYYY = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed in JavaScript
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}

const formattedDateLong = (date) =>

  new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

const formattedDateNoYear = (date) =>

  new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
  });


const formatDateTime = (datetimeStr) => {
  const dateObj = new Date(datetimeStr);

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  const dateFormatted = `${day}/${month}/${year}`;
  const timeFormatted = dateObj.toLocaleTimeString();
  const longDateFormatted = dateObj.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const shortFullFormatted = dateObj.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  const longFullFormatted = dateObj.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const defaultFormat = `${dateFormatted}(${timeFormatted})`;
  return {
    toString: () => defaultFormat,
    full: `${dateFormatted}, ${timeFormatted}`,
    date: dateFormatted,
    time: timeFormatted,
    longdate: `${longDateFormatted}`,
    longdatetime: `${longDateFormatted}, ${timeFormatted}`,
    shortfull: `${shortFullFormatted}`,
    longfull: `${longFullFormatted}`
  };
};

export { formatDate, formattedTime, formattedDate, datearray, formatTime, formatDateDDMMYYYY, formatDateDD_MM_YYYY, formattedDateLong, formattedDateNoYear, formatDateTime, formatDateDDMMYYYYmonth, formatDateIndian, formatDateDDMMYYYYmonthNew }